import { useEffect } from 'react';
import { authorize, loginStatus } from '../functions/API';
import { useEditor } from './useEditor';
import { useScene } from './useScene';

export const userHooks = () => {
  const scene = useScene();
  const { setUserSession, setLauncherThemeSession } = useEditor();

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const themeID = params.get('themeId');
      const versionID = params.get('versionId');
      try {
        const { email, planName, paymentModel } = await loginStatus();

        let isAuthorized = null;
        if (themeID) {
          try {
            await authorize({ themeID });
            isAuthorized = true;
          } catch {
            isAuthorized = false;
          }
        }

        setUserSession({
          isLoggedIn: true,
          isAuthorized,
          email,
          planName,
          paymentModel,
        });
      } catch {
        setUserSession({
          isLoggedIn: false,
          isAuthorized: null,
          email: null,
          planName: null,
          paymentModel: null,
        });
      }
      setLauncherThemeSession({
        isThemeLoaded: false,
        themeID,
        versionID,
        versions: [],
        images: [],
      });
    })();
  }, []);

  // Save last history state in local storage
  useEffect(() => {
    if (!scene.lastHistoryState?.launcherConfigJSON) return;

    localStorage.setItem(
      'lastHistoryStateJSON',
      JSON.stringify(scene.lastHistoryState)
    );
  }, [scene.lastHistoryState]);
};
